// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__MzWGx","large":"styles_large__2mmnT"};